<template>
  <div class="g-page">
    <div class="content-container">

      <!-- HEADER -->
      <div class="header-row">
        <h2 class="page-title">Reviziyalar tarixi</h2>
        <div class="header-actions">
          <div class="search-box">
            <b-icon icon="search" class="search-icon"></b-icon>
            <input v-model="searchText" type="text" placeholder="Sklad / foydalanuvchi / izoh..." class="search-input" />
          </div>
          <button class="refresh-btn" @click="fetchHistory" :disabled="loading" title="Yangilash">
            <b-icon icon="arrow-clockwise"></b-icon>
          </button>
          <div class="total-badge count-badge">Soni: <b>{{ filteredList.length }}</b></div>
        </div>
      </div>

      <!-- JADVAL -->
      <div class="table-card">
        <div class="table-wrapper">
          <table class="custom-table">
            <thead>
              <tr>
                <th style="width:50px">№</th>
                <th>SANA</th>
                <th>SKLAD</th>
                <th>FOYDALANUVCHI</th>
                <th class="text-right">TIZIM</th>
                <th class="text-right">HAQIQIY</th>
                <th class="text-right">FARQ</th>
                <th>IZOH</th>
                <th style="width:60px; text-align:center">AMAL</th>
              </tr>
            </thead>
            <tbody v-for="(r, index) in filteredList" :key="r.id">
              <tr :class="['clickable-row', { expanded: expandedId === r.id }]" @click="toggleExpand(r)">
                <td><span class="id-badge">{{ r.number || (index + 1) }}</span></td>
                <td>{{ formatDate(r.created_at) }}</td>
                <td>{{ r.sklad ? r.sklad.name : '-' }}</td>
                <td><span class="text-muted small">{{ userName(r) }}</span></td>
                <td class="text-right">{{ formatNum(r.count_all) }}</td>
                <td class="text-right font-bold">{{ formatNum(r.total_real_count) }}</td>
                <td class="text-right">
                  <span :class="diffClass(r.total_difference)">
                    {{ Number(r.total_difference) > 0 ? '+' : '' }}{{ formatNum(r.total_difference) }}
                  </span>
                </td>
                <td><span class="text-muted small">{{ r.comment || '-' }}</span></td>
                <td class="text-center">
                  <button class="eye-btn" :title="expandedId === r.id ? 'Yopish' : 'Ko\'rish'">
                    <b-icon :icon="expandedId === r.id ? 'eye-slash' : 'eye'"></b-icon>
                  </button>
                </td>
              </tr>

              <!-- KENGAYTIRILGAN: tarkib -->
              <tr v-if="expandedId === r.id" class="detail-row">
                <td colspan="9">
                  <div class="detail-container">
                    <div v-if="detailLoading" class="text-center py-3 text-muted">Yuklanmoqda...</div>
                    <table v-else-if="detailItems.length > 0" class="inner-table">
                      <thead>
                        <tr>
                          <th>Mahsulot</th>
                          <th class="text-right">Tizim soni</th>
                          <th class="text-right">Haqiqiy</th>
                          <th class="text-right">Farq</th>
                          <th class="text-right">Tannarx</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(it, i) in detailItems" :key="i">
                          <td>{{ it.product ? it.product.extra_name : ('#' + it.product_id) }}</td>
                          <td class="text-right">{{ formatNum(it.count) }}</td>
                          <td class="text-right font-bold">{{ formatNum(it.real_count) }}</td>
                          <td class="text-right">
                            <span :class="diffClass(it.difference)">
                              {{ Number(it.difference) > 0 ? '+' : '' }}{{ formatNum(it.difference) }}
                            </span>
                          </td>
                          <td class="text-right">{{ formatNum(it.body_price) }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div v-else class="text-center py-3 text-muted">Tarkib topilmadi</div>
                  </div>
                </td>
              </tr>
            </tbody>

            <tbody v-if="!loading && filteredList.length === 0">
              <tr>
                <td colspan="9" class="empty-row">
                  <div class="py-5 text-center text-muted">
                    {{ searchText ? 'Qidiruv natijasi topilmadi' : 'Reviziya topilmadi' }}
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-if="loading">
              <tr><td colspan="9" class="text-center py-5"><b-spinner variant="primary"></b-spinner></td></tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'RevisionHistory',
  data() {
    return {
      loading: false,
      list: [],
      searchText: '',
      expandedId: null,
      detailItems: [],
      detailLoading: false,
    };
  },
  computed: {
    filteredList() {
      const q = (this.searchText || '').toLowerCase().trim();
      if (!q) return this.list;
      return this.list.filter(r =>
        (r.sklad && (r.sklad.name || '').toLowerCase().includes(q)) ||
        (this.userName(r) || '').toLowerCase().includes(q) ||
        (r.comment || '').toLowerCase().includes(q) ||
        String(r.number || '').includes(q)
      );
    },
  },
  mounted() {
    this.fetchHistory();
  },
  methods: {
    async fetchHistory() {
      this.loading = true;
      try {
        const res = await axios.get('api/v1/revision');
        this.list = Array.isArray(res.data) ? res.data : [];
      } catch (e) {
        console.error('Reviziya tarixini yuklashda xato:', e);
        this.list = [];
      } finally {
        this.loading = false;
      }
    },
    async toggleExpand(r) {
      if (this.expandedId === r.id) { this.expandedId = null; return; }
      this.expandedId = r.id;
      this.detailItems = [];
      this.detailLoading = true;
      try {
        const res = await axios.get('api/v1/revision/id/' + r.id);
        this.detailItems = (res.data && res.data.revision_table) || [];
      } catch (e) {
        this.detailItems = [];
      } finally {
        this.detailLoading = false;
      }
    },
    userName(r) {
      if (!r.user) return '-';
      return `${r.user.first_name || ''} ${r.user.last_name || ''}`.trim() || '-';
    },
    diffClass(v) {
      const n = Number(v || 0);
      return n > 0 ? 'diff-plus' : (n < 0 ? 'diff-minus' : 'diff-zero');
    },
    formatNum(v) {
      const n = Number(v || 0);
      return n.toLocaleString('ru-RU').replace(/ /g, ' ');
    },
    formatDate(ts) {
      if (!ts) return '-';
      return this.$formatDate(ts);
    },
  },
};
</script>

<style scoped>
.g-page {
  padding: 20px;
  background: #f8fafc;
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.content-container {
  max-width: 1280px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.page-title {
  color: #4f46e5;
  font-weight: 800;
  font-size: 24px;
  margin: 0;
}
.header-actions { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }
.search-box { position: relative; display: flex; align-items: center; }
.search-icon { position: absolute; left: 12px; color: #94a3b8; }
.search-input {
  height: 40px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  padding: 0 12px 0 36px;
  font-size: 14px;
  outline: none;
  background: white;
  width: 240px;
}
.refresh-btn {
  height: 40px;
  width: 40px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: white;
  color: #4f46e5;
  cursor: pointer;
}
.refresh-btn:hover:not(:disabled) { background: #eef2ff; }
.total-badge {
  background: #eef2ff;
  color: #4f46e5;
  border: 1px solid #c7d2fe;
  border-radius: 12px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
}
.count-badge { background: #f1f5f9; color: #475569; border-color: #e2e8f0; }

.table-card {
  background: white;
  border-radius: 20px;
  padding: 10px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.03);
  border: 1px solid #f1f5f9;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.table-wrapper { overflow-y: auto; flex-grow: 1; }
.custom-table { width: 100%; border-collapse: separate; border-spacing: 0; }
.custom-table th {
  position: sticky;
  top: 0;
  background: white;
  z-index: 5;
  padding: 14px 15px;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  border-bottom: 1px solid #f1f5f9;
  text-align: left;
}
.custom-table td {
  padding: 13px 15px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
  font-size: 14px;
}
.id-badge {
  background: #eef2ff;
  padding: 3px 8px;
  border-radius: 7px;
  font-weight: 700;
  color: #4f46e5;
  font-size: 12px;
}
.text-muted { color: #94a3b8; }
.small { font-size: 12px; }
.font-bold { font-weight: 700; }
.text-right { text-align: right; }
.text-center { text-align: center; }
.diff-plus { color: #16a34a; font-weight: 800; }
.diff-minus { color: #e11d48; font-weight: 800; }
.diff-zero { color: #94a3b8; }

.clickable-row { cursor: pointer; transition: background 0.15s; }
.clickable-row:hover td { background: #f5f3ff; }
.clickable-row.expanded td { background: #f5f3ff; }
.eye-btn {
  width: 30px;
  height: 28px;
  border-radius: 6px;
  border: none;
  background: #eef2ff;
  color: #4f46e5;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.eye-btn:hover { background: #4f46e5; color: white; }

.detail-row td { background: #faf9ff; padding: 0 !important; border-bottom: 2px solid #e2e8f0; }
.detail-container { padding: 12px 16px; }
.inner-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0,0,0,0.03);
}
.inner-table thead th {
  background: #f1f5f9;
  padding: 8px 10px;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  text-align: left;
}
.inner-table tbody td { padding: 8px 10px; border-bottom: 1px solid #f1f5f9; color: #334155; }
.inner-table tbody tr:last-child td { border-bottom: none; }
.empty-row { text-align: center; }
</style>
